import { render, staticRenderFns } from "./incubation.vue?vue&type=template&id=02d8e428&scoped=true"
import script from "./incubation.vue?vue&type=script&lang=js"
export * from "./incubation.vue?vue&type=script&lang=js"
import style0 from "./incubation.vue?vue&type=style&index=0&id=02d8e428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d8e428",
  null
  
)

export default component.exports